<script>
    import { hsl2rgb } from '@scanex/color';
    import { onMount } from 'svelte';
    import './ColorArea.css';

    const TIMEOUT = 70;

    export let hue = 0;
    export let saturation = 1.0;
    export let lightness = 0.5;

    let container;
    let canvas;
    let sampler;

    let halfWidth = 0;
    let halfHeight = 0;            
    let width = 0;
    let height = 0;
    let moving = false;
    let offsetX = 0;
    let offsetY = 0;

    onMount(() => {
        const samplerRect = sampler.getBoundingClientRect();
        halfWidth = samplerRect.width / 2;
        halfHeight = samplerRect.height / 2;            
        width = canvas.clientWidth;
        height = canvas.clientHeight;
        moving = false;
        offsetX = 0;
        offsetY = 0;
    });

    $: {
        setTimeout(() => {
            sampler.style.left = `${Math.round((1 - saturation) * width) + 2}px`;
        }, TIMEOUT);
    }

    $: {
        setTimeout(() => {
            sampler.style.top = `${Math.round((1 - lightness) * height) + 2}px`;
            const {r, g, b} = hsl2rgb(hue, saturation, 1 - lightness);
            const color = `rgb(${[r,g,b].join(',')})`;
            sampler.style.backgroundColor = color;
        }, TIMEOUT);
    }

    $: {
        setTimeout(() => {                        
            let ctx = canvas.getContext('2d');
            let imgData = ctx.getImageData (0, 0, canvas.width, canvas.height);
            const {data, width, height} = imgData;            
            let k = 0;            
            for (let i = height - 1; i >= 0; --i) {
                for (let j = width - 1; j >= 0; --j) {
                    let s = j / width;
                    let l = i / height;
                    let {r, g, b} = hsl2rgb(hue, s, l);
                    data[k + 0] = r;
                    data[k + 1] = g;
                    data[k + 2] = b;
                    data[k + 3] = 255;                    
                    k += 4;
                }
            }            
            ctx.putImageData (imgData, 0, 0); 
        }, TIMEOUT);
    }

    function click (e) {                                     
        const {left, top} = canvas.getBoundingClientRect();
        const x = e.clientX - left;
        const y = e.clientY - top;
        saturation = 1 - x / width;
        lightness = 1 - y / height;        
    }
    function start (e) {        
        offsetX = e.offsetX;
        offsetY = e.offsetY;
        moving = true;
    }
    function move (e) {                
        if (moving) {            
            document.body.style.cursor = 'pointer';
            const {left, top} = canvas.getBoundingClientRect();
            // handle x
            let x = e.clientX - offsetX + halfWidth - left;
            if (x < 0) {
                x = 0;
            }
            else if (x > width) {                 
                x = width;
            }         
            // handle y
            let y = e.clientY - offsetY + halfHeight - top;
            if (y < 0) {                     
                y = 0;
            }
            else if (y > height) {                        
                y = height;
            }                    
            saturation = 1 - x / width;
            lightness = 1 - y / height;
        }
    }
    function stop (e) {
        if (moving) {            
            document.body.style.cursor = 'initial';
            offsetX = 0;
            offsetY = 0;
            moving = false;
        }
    }
</script>

<svelte:window on:mousemove|stopPropagation="{move}" on:mouseup|stopPropagation="{stop}" />
<div bind:this="{container}" class="color-area">    
    <canvas bind:this="{canvas}" on:click|stopPropagation="{click}"></canvas>
    <div class="sampler" bind:this="{sampler}" on:mousedown|stopPropagation="{start}"></div>
</div>